export const HOSTNAME = process.env.NEXT_PUBLIC_HOSTNAME
export const PORT = process.env.NEXT_PUBLIC_PORT
export const PROTOCOL = process.env.NEXT_PUBLIC_PROTOCOL
export const HOST = process.env.NEXT_PUBLIC_HOST
export const API_URL = process.env.NEXT_PUBLIC_API_URL
export const STRIPE_PUBLISHABLE_KEY =
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY
export const STATIC_URL = process.env.NEXT_PUBLIC_STATIC_URL

export const SETTINGS = {
  HOSTNAME,
  PORT,
  PROTOCOL,
  HOST,
  API_URL,
  STRIPE_PUBLISHABLE_KEY,
  STATIC_URL,
}
